import { Platform } from "@angular/cdk/platform";
import { inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeviceCapabilityService {
  private platform = inject(Platform);

  hasTouchCapabilities() {
    return window.matchMedia("(any-pointer: coarse)").matches;
  }

  hasFullScreenCapabilities() {
    return !this.platform.IOS;
  }
}
